import { useState } from "react";
import { Box, Typography } from "@mui/material";
import DialogContainer from "../../../../components/dialog-container/dialog-container";
import "./add-role.css";
import TextInput from "../../../../components/textinput/textinput";
import { useFormik } from "formik";
import * as yup from "yup";
import { addRole } from "../../../../utils/APICalls";
import Loading from "../../../../components/loading/loading";
import ErrorNotification from "../../../../components/error-notification/error-notification";
import { userType } from "../../../../utils/Constant";
import { useDispatch } from "react-redux";
import { roleRequest } from "../../../../redux/roles/slice";

type props = {
  showDialog: boolean;
  closeDialog: any;
  roleType?: string;
  onAddRole?: any;
  setShowRoleCreatedAlert?:Function;
};

interface FormValues {
  name?: string;
}

const ValidationSchema = yup.object({
  name: yup.string().required("This field can't be empty"),
});

export default function AddRole({
  showDialog,
  closeDialog,
  roleType,
  onAddRole,
  setShowRoleCreatedAlert,
}: props) {
  const [showLoader, setShowLoader] = useState(false);
  const [showErrorNotification, setShowErrorNotification] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const dispatch = useDispatch();

  const formik = useFormik<FormValues>({
    initialValues: {
      name: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: (value) => {
      let type;
      if (roleType === "Internal") {
        type = userType.tenant;
      } else if (roleType === "Client") {
        type = userType.client;
      } else if (roleType === "Inspection Firm") {
        type = userType.inspector;
      }
      const data = {
        roleType: type,
        ...value,
      };
      addRoleName(data);
    },
  });

  const addRoleName = async (data: any) => {
    setShowLoader(true);
    const response = await addRole(data);
    setShowLoader(false);
    if (response?.status === 201) {
      dispatch(roleRequest(data.roleType));
      onAddRole(response?.data.id);
      formik.resetForm();
      closeDialog();
      setShowRoleCreatedAlert?.(true)
    } else {
      setErrorMessage(
        response?.data?.detail || "Failed to create role. Please try again."
      );
      setShowErrorNotification(true);
    }
  };

  return (
    <DialogContainer
      closeDialog={closeDialog}
      showDialog={showDialog}
      title={`Add ${roleType} Role`}
      buttonText="ADD ROLE"
      onSubmit={formik.handleSubmit}
    >
      <form onSubmit={formik.handleSubmit}>
        <Box className="add-role-layout">
          <Typography className="add-role-label-txt">Role Name</Typography>
          <TextInput
            className="field-input"
            id="name"
            name="name"
            label="Role Name"
            variant="outlined"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
          />
        </Box>
      </form>
      {showLoader && <Loading />}
      <ErrorNotification
        show={showErrorNotification}
        title="Error"
        message={errorMessage}
        onClose={() => setShowErrorNotification(false)}
      />
    </DialogContainer>
  );
}
